import { render, staticRenderFns } from "./AddonObjectivesEditor.vue?vue&type=template&id=4fea7948&scoped=true&"
import script from "./AddonObjectivesEditor.vue?vue&type=script&lang=js&"
export * from "./AddonObjectivesEditor.vue?vue&type=script&lang=js&"
import style0 from "./AddonObjectivesEditor.vue?vue&type=style&index=0&id=4fea7948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fea7948",
  null
  
)

export default component.exports